import React, {
  useContext,
  useState,
  useCallback,
  useMemo,
  useEffect,
} from 'react'
import R from 'ramda'
import { Button, Input, Tabs, Radio, Upload, Icon, Modal } from 'antd'
import { connect } from 'react-redux'
import qs from 'querystring'
import * as ScreenPermissions from 'core/EventActions'
import {
  rowHeaderRender,
  SEVERITY_ERROR_COLOR,
  SEVERITY_WARNING_COLOR,
  hasAccesPermits,
} from 'core/utils'

import {
  getUtilityNameMap,
  getUnitNameMap,
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getEventTypes,
} from 'core/selectors'

import * as freeEditEngine from '@integec/grid-tools/lib/editEngine'
import { CriteriaRow, Title, Content, FullHeightSizer } from 'core/screen-util'
import {
  strCol,
  numCol,
  intCol,
  dateTimeCol,
} from '@integec/grid-tools/lib/cols'
import {
  YNBooleanTypes,
  utilityHeader,
  unitIdHeader,
} from 'core/HeaderColTypeProps'

import EditableGrid from 'core/component/EditableGrid'

import { applyEdits } from '@integec/grid-tools/lib/editEngine'
import {
  resubmitData,
  getAuthorization,
  getCredentials,
  getContribCondtition,
} from 'api/pgads.js'
import { SpinContext, ErrorContext } from 'context'
import Grid, {
  virtualizedGridRenderer,
  defaultVirtualizedCellRender,
  toSelectionColProps,
} from '@integec/grid-tools'
import moment from 'moment'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
import { NYISO_CLIENT } from 'client'
const { TabPane } = Tabs
const header = [
  utilityHeader,
  unitIdHeader,
  strCol({
    ident: 'cardCode',
    display: 'Card Code',
    isFiltered: true,
  }),
  intCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
    width: 70,
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isFiltered: true,
    width: 70,
  }),
  intCol({
    ident: 'eventNum',
    display: 'Event Num',
    isFiltered: true,
    width: 70,
  }),
  intCol({
    ident: 'errorCode',
    display: 'Error Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'error',
    display: 'Error',
    width: 1000,
    isFiltered: true,
    ellipsis: true,
    alignment: 'left',
  }),
  intCol({
    ident: 'fromchar',
    display: 'From Char',
    isFiltered: true,
  }),
  intCol({
    ident: 'tochar',
    display: 'To Char',
    isFiltered: true,
  }),
  intCol({
    ident: 'seqNo',
    display: 'Seq. Number',
    isFiltered: true,
  }),
  intCol({
    ident: 'severity',
    display: 'Severity',
    isFiltered: true,
  }),
].map(d => ({ ...d, rowHeaderBackgroundColor: '#eee', height: 30 }))

const DataImportAntd = ({
  apiTargetInfo,
  utilityNameMap,
  unitNameMap,
  envConfig,
  actionPermits,
  eventTypes,
}) => {
  const disableEdit = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.DATAIMPORT_DISABLE_EDIT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const csvImportEnable = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.DATAIMPORT_CSV_TYPE],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hideFileTypeRadioGroup = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.HIDE_DATA_IMPORT_RADIO_GROUP],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const { setSpinning } = useContext(SpinContext)
  // const [err, setError] = useState(null)
  const { setError } = useContext(ErrorContext)

  const [fileType, setFileType] = useState('NERC')
  const [fuzzyFilter, setFuzzyFilter] = useState('')

  const [importResponse, setImportResponse] = useState({})
  const [editInfo95, setEditInfo95] = useState(
    freeEditEngine.generateInitialEditInfo()
  )
  const [editInfo97, setEditInfo97] = useState(
    freeEditEngine.generateInitialEditInfo()
  )
  const [editInfo99, setEditInfo99] = useState(
    freeEditEngine.generateInitialEditInfo()
  )
  const [card95, setCard95] = useState([])
  const [card97, setCard97] = useState([])
  const [card97Extension, setCard97Extension] = useState([])
  const [card99, setCard99] = useState([])

  // const [notes, showNotes] = useState(false)
  const [activeKey, setActiveKey] = useState('error')

  const [contribConditionMap, setContribConditionMap] = useState({})

  const CLIENT = envConfig.clientId || 'INTEG'

  const isNYISO = CLIENT === NYISO_CLIENT

  useEffect(
    _ => {
      getContribCondtition(apiTargetInfo).fork(
        _ => _,
        data => {
          const contribConditionMap = R.compose(
            R.fromPairs,
            R.map(({ code, description }) => [code, code + ' - ' + description])
          )(data)
          setContribConditionMap(contribConditionMap)
        }
      )
    },
    [apiTargetInfo]
  )

  const clearData = _ => {
    setEditInfo95(freeEditEngine.generateInitialEditInfo())
    setEditInfo97(freeEditEngine.generateInitialEditInfo())
    setEditInfo99(freeEditEngine.generateInitialEditInfo())
    setCard95([])
    setCard97([])
    setCard99([])
    setCard97Extension([])
    setImportResponse({})
  }

  const getValidDate = dateStr => {
    if (dateStr === undefined || dateStr.trim().length === 0) return undefined
    return moment(dateStr, 'MM/DD/YYYY HH:mm', false).format(
      'YYYY-MM-DDTHH:mm:ss'
    )
  }
  const updateDateinCard97 = dateStr => {
    if (dateStr === undefined || dateStr.trim().length === 0) return undefined
    return moment(dateStr, 'YYYY-MM-DDTHH:mm:ss', false).format(
      'MM/DD/YYYYTHH:mm'
    )
  }

  const setCard97Dates = useCallback(card97 => {
    return card97.map(e => ({
      ...e,
      eventStart: updateDateinCard97(e.eventStart),
      eventEnd: updateDateinCard97(e.eventEnd),
      workStart: updateDateinCard97(e.workStart),
      workEnd: updateDateinCard97(e.workEnd),
    }))
  }, [])

  const getExtensionforSave = finalCard97 => {
    const getExternalData = ext => {
      const { unitId, year, eventNum, eventTypeExternal = '0' } = ext

      const multpleDAta = finalCard97.filter(
        c =>
          parseInt(c.year) === parseInt(year) &&
          c.unitId === unitId &&
          parseInt(c.eventNum) === parseInt(eventNum)
      )

      const lenght = multpleDAta.length

      const net = R.range(0, lenght)
        .map(i => {
          const fn = multpleDAta.find(f => parseInt(f.eventIdx) === i + 1)
          if (!fn) return eventTypeExternal.charAt(i)
          else {
            if (fn.included !== 'Y') return ' '
          }

          return fn.eventTypeExternal || '0'
        })
        .join('')

      return net
    }

    return (card97Extension || []).map(ext => ({
      ...ext,
      eventTypeExternal: getExternalData(ext),
    }))
  }

  const getFinalData = _ => {
    const data95 = { data: card95, editInfo95 }
    const editedData95 = applyEdits(data95)
    const data97 = { data: card97, editInfo97 }
    let editedData97 = applyEdits(data97)
    const data99 = { data: card99, editInfo99 }
    const editedData99 = applyEdits(data99)

    editedData97 = editedData97.map(e => ({
      ...e,
      eventStart: getValidDate(e.eventStart),
      eventEnd: getValidDate(e.eventEnd),
      workStart: getValidDate(e.workStart),
      workEnd: getValidDate(e.workEnd),
    }))

    const card97Extension = getExtensionforSave(editedData97)

    const finalData = {
      card95List: editedData95.filter(d => d.included === 'Y'),
      card97List: editedData97.filter(d => d.included === 'Y'),
      card99List: editedData99.filter(d => d.included === 'Y'),
      card97Extension,
    }
    return finalData
  }

  const saveData = () => {
    const finalData = getFinalData()
    setSpinning(true)
    resubmitData(apiTargetInfo)(finalData, fileType).fork(setError, data => {
      const {
        tempCard95,
        tempCard97,
        tempCard99,
        temperror,
        tempCard97Extension = [],
      } = data
      setSpinning(false)
      setImportResponse(data)

      if (!isErrorContains(temperror)) {
        // message.info('Data submited successfully.')

        Modal.info({
          title: `Data Import`,
          width: 500,
          height: 250,
          content: (
            <div>
              <div>Data submited successfully.</div>
              <div>
                Please perform a level 2 validation to fully complete your
                monthly GADS data submission.
              </div>
            </div>
          ),
        })

        // if import successfully then no need to show card data  by Wing sir 20/7/2023
        setCard95([])
        setCard97([])
        setCard99([])
        setCard97Extension([])

        setEditInfo95(freeEditEngine.generateInitialEditInfo())
        setEditInfo97(freeEditEngine.generateInitialEditInfo())
        setEditInfo99(freeEditEngine.generateInitialEditInfo())
        setCard97Extension([])
      } else {
        setCard95(tempCard95.map(d => ({ ...d, included: 'Y' })))
        setCard97Extension(tempCard97Extension)
        const modData97 = setCard97Dates(tempCard97)
          .map(d => ({ ...d, included: 'Y' }))
          .map(d => attachExtensionData(d, tempCard97Extension))
        setCard97(modData97)
        setCard99(tempCard99.map(d => ({ ...d, included: 'Y' })))
        setEditInfo95(freeEditEngine.generateInitialEditInfo())
        setEditInfo97(freeEditEngine.generateInitialEditInfo())
        setEditInfo99(freeEditEngine.generateInitialEditInfo())
      }

      setActiveKey('error')
    })
  }

  const onChange = e => {
    setFileType(e.target.value)
    clearData(false)
  }

  const attachExtensionData = (card97, extension) => {
    const { unitId, eventNum, year, eventIdx } = card97

    const extn = extension.find(
      f =>
        parseInt(f.year) === parseInt(year) &&
        f.unitId === unitId &&
        parseInt(f.eventNum) === parseInt(eventNum)
    ) || { eventIdx: 1, eventTypeExternal: '0' }

    const { eventTypeExternal = '0' } = extn
    const curExternal = eventTypeExternal.substr(parseInt(eventIdx - 1), 1)
    return { ...card97, eventTypeExternal: curExternal }
  }

  const url = ft =>
    `${apiTargetInfo.baseUrl}/file-import/import-edit?${qs.stringify({
      fileType: ft,
    })}`
  const fileProps = {
    name: 'file',
    action: url(fileType),
    method: 'POST',
    headers: getAuthorization(apiTargetInfo),
    ...getCredentials(apiTargetInfo),
  }
  // eslint-disable-next-line no-unused-vars
  const [fileName, setFileName] = useState('')
  const onFileUploadChange = useCallback(
    info => {
      if (info.file.status === 'done') {
        const {
          tempCard95,
          tempCard97,
          tempCard97Extension,
          tempCard99,
          temperror,
        } = info.file.response
        setFileName(info.file.name)
        setImportResponse({ temperror })
        if (!isErrorContains(temperror)) {
          // message.success(`${info.file.name} file uploaded successfully`)
          Modal.info({
            title: `Data Import`,
            width: 500,
            height: 250,
            content: (
              <div>
                <div>{info.file.name} file uploaded successfully.</div>
                <div>
                  Please perform a level 2 validation to fully complete your
                  monthly GADS data submission.
                </div>
              </div>
            ),
          })

          // if data is success then no need to show the data by Wing sir
          setCard95([])
          setCard97([])
          setCard99([])
          setCard97Extension([])
          setEditInfo95(freeEditEngine.generateInitialEditInfo())
          setEditInfo97(freeEditEngine.generateInitialEditInfo())
          setEditInfo99(freeEditEngine.generateInitialEditInfo())
        } else {
          setImportResponse({ temperror })
          setCard95(tempCard95.map(d => ({ ...d, included: 'Y' })))
          const card97DAtaMod = setCard97Dates(tempCard97)
            .map(d => ({ ...d, included: 'Y' }))
            .map(d => attachExtensionData(d, tempCard97Extension))
          setCard97(card97DAtaMod)

          const genExtData = d97 => {
            const { utility, unit, unitId, year, eventNum } = d97
            const ext = tempCard97Extension.find(
              e =>
                e.year === year &&
                e.unitId === unitId &&
                (e.eventNum === eventNum || e.eventNum === eventNum + '')
            )
            return (
              ext || {
                utility,
                unit,
                unitId,
                eventTypeExternal: '0',
                eventIdx: 1,
                year,
                eventNum,
              }
            )
          }
          const finExtData = card97DAtaMod
            .filter(f => f.eventIdx === '1' || f.eventIdx === 1)
            .map(d => genExtData(d))
          setCard97Extension(finExtData)

          // setCard97Extension(tempCard97Extension)

          setCard99(tempCard99.map(d => ({ ...d, included: 'Y' })))
          setEditInfo95(freeEditEngine.generateInitialEditInfo())
          setEditInfo97(freeEditEngine.generateInitialEditInfo())
          setEditInfo99(freeEditEngine.generateInitialEditInfo())
        }

        setSpinning(false)
        setActiveKey('error')
        // retrieveData()
      } else if (info.file.status === 'error') {
        // reportError(info.file.response)
        // onError(info)
        setError(info.file.response)
        if (info.file.response.appExceptionId !== 100) {
          // message.error(`${info.file.name} file have invalid data`)
          Modal.error({
            title: `Data Import`,
            width: 500,
            height: 250,
            content: <div>{info.file.name} file have invalid data.</div>,
          })
        }
        setImportResponse({})
        setSpinning(false)
      }
    },
    [setCard97Dates, setError, setSpinning]
  )

  const monthOption = R.range(1, 13).map(i => ({
    key: `${i}`,
    value: `${i}`,
    text: `${i}`,
  }))

  const cellRender = props => {
    const { gridToolProps, reactVirtualizedProps } = props
    const { data } = gridToolProps
    const { style, rowIndex } = reactVirtualizedProps
    const { severity } = data[rowIndex]
    // const style = reactVirtualizedProps.style
    return defaultVirtualizedCellRender({
      ...props,
      hoverSelectionColor: '#000000',
      selectionColor: '#000000',
      selectionBackgroundColor: 'white',
      hoverSelectionBackgroundColor: 'white',
      // hoverColor: '#00000',
      // color: '#00000',
      style: {
        ...style,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        borderTop: '1px solid #cc',
        backgroundColor:
          severity === '1' ? SEVERITY_ERROR_COLOR : SEVERITY_WARNING_COLOR,
        ellipsis: true,
      },
    })
  }

  const headerWithFormatter = useCallback(
    header =>
      header.map(header =>
        header.ident === 'utility'
          ? {
              ...header,
              ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : header.ident === 'unitId'
          ? {
              ...header,
              choices: [],
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unitId] || rowData.unitId,
            }
          : header.ident === 'month'
          ? {
              ...header,
              choices: monthOption,
            }
          : header
      ),
    [monthOption, unitNameMap, utilityNameMap]
  )
  const isEditable = ({ header }) => {
    if (disableEdit) return false
    if (header.ident === 'modifier' || header.ident === 'modifiedDate')
      return false

    return !header.isKey
  }

  const card97SortHeader = useMemo(
    _ => [
      utilityHeader,
      unitIdHeader,
      intCol({
        ident: 'year',
        display: 'Year',
        isKey: true,
        width: 70,
        sortOrder: 'asc',
      }),
      intCol({
        ident: 'eventNum',
        display: 'Event Number',
        isKey: true,
        width: 70,
        sortOrder: 'asc',
      }),
      intCol({
        ident: 'eventIdx',
        display: 'Event Index',
        isKey: true,
        width: 70,
        sortOrder: 'asc',
      }),
      strCol({
        ident: 'revCode',
        display: 'Revision Code',
      }),
    ],
    []
  )

  const card95HeadersMemo = useMemo(_ => headerWithFormatter(Card95Headers), [
    headerWithFormatter,
  ])

  const card99HeaderMemo = useMemo(_ => headerWithFormatter(Card99Headers), [
    headerWithFormatter,
  ])

  return (
    <>
      <div
        style={{
          backgroundColor: '#f0f2f5',
          marginLeft: '20px',
          marginRight: '20px',
        }}
      >
        <CriteriaRow>
          <Title
            style={{
              marginRight: '15px',
              marginBottom: '5px',
            }}
          >
            Data Import
          </Title>
          <div style={{ flex: '1 1 0px' }} />
          {!hideFileTypeRadioGroup && (
            <Radio.Group
              onChange={onChange}
              value={fileType}
              buttonStyle="solid"
            >
              <Radio value="NERC">NERC 05 & 07</Radio>
              <Radio value="PJM">PJM</Radio>
              {csvImportEnable && <Radio value="CSV">CSV</Radio>}
              {/* <Radio value="XML">XML</Radio> */}
            </Radio.Group>
          )}
          <Upload
            {...fileProps}
            onChange={data => {
              setSpinning(true)
              onFileUploadChange(data)
            }}
            multiple={false}
            showUploadList={false}
          >
            <Button style={{ marginLeft: '10px' }}>
              <Icon type="upload" /> Click to Upload
            </Button>
          </Upload>
          {/* <div style={{ flex: '1 1 0px' }} /> */}
          <div style={{ marginLeft: '10px' }}>File : {fileName}</div>
          <div style={{ flex: '1 1 0px' }} />
          {isNYISO && (
            <div
              style={{
                backgroundColor: '#f9f9f9',
                padding: '5px 10px',
                fontSize: '13px',
                lineHeight: '1.5',
                borderRadius: '4px',
                maxWidth: '650px',
              }}
            >
              NERC GADS data must be submitted using the NERC 05-07 format. Both
              Performance (05) and Event (07) <br /> data must be submitted
              together in a single file. Both Performance and Event data must be
              matching <br /> for the same Time Period.
            </div>
          )}
          <div style={{ flex: '1 1 0px' }} />
          {/* <Button type="primary">Edit</Button> */}
          {/* <div css={{ flex: '1 1 0px' }} /> */}
          {/* {!disableEdit && (
            <Button
              onClick={_ => {
                showNotes(!notes)
              }}
              icon="pushpin"
            >
              {notes ? 'Hide Notes' : 'Show Notes'}
            </Button>
          )} */}
          <Input.Search
            placeholder="Filter"
            value={fuzzyFilter}
            style={{
              marginLeft: '10px',
              marginRight: '10px',
              flex: '0 0 200px',
            }}
            onChange={e => setFuzzyFilter(e.target.value)}
          />
        </CriteriaRow>
        {/* {notes && (
        <Content
            style={{ padding: '10px', marginTop: '5px', marginBottom: '5px' }}
        >
            <div>
              Error (Step 1) - The following errors were found. Please fix the
              file and re-upload or fix data in the Card 95/97/99 Tabs and then
              press Save
            </div>
            <div>
              Card 95 (Step 2) - Please save data in Card 95/97/99 Tabs and
              press Save. If data is all correct, you will get a Success
              Message. 
              <br />
              If the updated data still has a problem, then you will see a
              “Updated Data Errors” Tab which will show the errors.
              <br />
              You must go back to Step 2 and update the Card 95/97/99 again and
              press Save or go back to the Original file and update it.
          </div>
        </Content>
        )} */}
        <FullHeightSizer heightOffset={270}>
          {({ height, width }) => (
            <Content style={{ height: height + 20 }}>
              <Tabs
                activeKey={activeKey}
                onChange={activeKey => setActiveKey(activeKey)}
                tabBarExtraContent={
                  <div style={{ display: 'flex' }}>
                    {!disableEdit && (
                      <React.Fragment>
                        {/* <div
                          style={{
                            padding: '0px 20px 0px 20px',
                            background: 'antiquewhite',
                          }}
                        >
                          Edit Record on Uploaded Data & check saved status
                        </div> 
                        <div style={{ flex: '1 1 0px', width: '100px' }} /> */}

                        <Button
                          onClick={_ => saveData()}
                          type="danger"
                          icon="save"
                          disabled={
                            card95.length <= 0 &&
                            card97.length <= 0 &&
                            card99.length <= 0
                          }
                        >
                          Re-Submit
                        </Button>
                      </React.Fragment>
                    )}
                  </div>
                }
                style={{ height: 'inherit' }}
              >
                <TabPane tab="Error" key="error" forceRender>
                  <div style={{ margin: '2px', padding: '1px' }}>
                    <Grid
                      data={importResponse.temperror || []}
                      headers={headerWithFormatter(header)}
                      altBgColor="#ebebeb"
                      render={virtualizedGridRenderer({
                        autoFixColByKey: false,
                        rowHeaderRender,
                        height: height - 60,
                        width: width - 60,
                        cellRender,
                        headerRowHeight: 30,
                      })}
                      sortEnabled
                      initialSortOptions={[
                        { ident: 'seqNo', sortOrder: 'asc' },
                      ]}
                      sortOptions={[{ ident: 'seqNo', sortOrder: 'asc' }]}
                      fuzzyFilter={fuzzyFilter}
                    />
                  </div>
                </TabPane>
                <TabPane tab="Performance Data" key="card95" forceRender>
                  <EditableGrid
                    gridData={importResponse.tempCard95 || []}
                    header={card95HeadersMemo}
                    height={height - 50}
                    width={width - 60}
                    editInfo={editInfo95}
                    setEditInfo={setEditInfo95}
                    data={card95}
                    setData={setCard95}
                    isEditable={isEditable}
                    autoFixColByKey={false}
                    initialSortOptions={card95HeadersMemo}
                    sortOptions={card95HeadersMemo}
                  />
                </TabPane>
                <TabPane tab="Event Data" key="card97" forceRender>
                  <EditableGrid
                    gridData={importResponse.tempCard97 || []}
                    header={headerWithFormatter(
                      Card97Headers(eventTypes, contribConditionMap)
                    )}
                    height={height - 60}
                    width={width - 70}
                    editInfo={editInfo97}
                    setEditInfo={setEditInfo97}
                    data={card97}
                    setData={setCard97}
                    isEditable={isEditable}
                    sortEnabled
                    sortOptions={card97SortHeader}
                    initialSortOptions={card97SortHeader}
                  />
                </TabPane>
                <TabPane tab="Fuel data" key="card99" forceRender>
                  <EditableGrid
                    gridData={importResponse.tempCard99 || []}
                    header={card99HeaderMemo}
                    height={height - 60}
                    width={width - 60}
                    editInfo={editInfo99}
                    setEditInfo={setEditInfo99}
                    data={card99}
                    setData={setCard99}
                    isEditable={isEditable}
                    sortOptions={card99HeaderMemo}
                    initialSortOptions={card99HeaderMemo}
                  />
                </TabPane>
              </Tabs>
            </Content>
          )}
        </FullHeightSizer>
      </div>
    </>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  eventTypes: getEventTypes(state),
})

export const Card95Headers = [
  strCol({
    ident: 'included',
    display: 'Included',
    ...toSelectionColProps(YNBooleanTypes),
  }),
  utilityHeader,
  unitIdHeader,
  intCol({
    ident: 'year',
    display: 'Year',
    isKey: true,
    width: 70,
    sortOrder: 'asc',
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isKey: true,
    width: 70,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'revCode',
    display: 'Revision Code',
    ...toSelectionColProps({
      '0': '0 (Insert)',
      // eslint-disable-next-line no-useless-computed-key
      ['R']: 'R (Replace)',
      D: 'D (Delete)',
    }),
    width: 90,
  }),
  numCol({
    ident: 'netMaxCap',
    display: 'Net Maximum Capacity',
  }),
  numCol({
    ident: 'netDepCap',
    display: 'Net Dependable Capacity',
  }),
  numCol({
    ident: 'netActGen',
    display: 'Net Actual Generation',
  }),
  intCol({
    ident: 'loadChar',
    display: 'Load Characteristics',
  }),
  intCol({
    ident: 'attStart',
    display: 'Attempted Starts',
  }),
  intCol({
    ident: 'actualStart',
    display: 'Actual Starts',
  }),
  numCol({
    ident: 'servHour',
    display: 'Service Hours',
  }),
  numCol({
    ident: 'resHour',
    display: 'Reserve Hours',
  }),
  numCol({
    ident: 'pumphour',
    display: 'Pump Hour',
  }),
  numCol({
    ident: 'syncHour',
    display: 'Synchronous Hours',
  }),
  numCol({
    ident: 'grossMaxCap',
    display: 'Gross Maximum Capacity',
  }),
  numCol({
    ident: 'grossDepCap',
    display: 'Gross Dependable Capacity',
  }),
  numCol({
    ident: 'grossActGen',
    display: 'Gross Actual Generation',
  }),
  strCol({
    ident: 'loadDesc',
    display: 'Load Description',
    desc: 200,
  }),
]

export const Card97Headers = (eventTypes, contribMap) => [
  strCol({
    ident: 'included',
    display: 'Included',
    ...toSelectionColProps(YNBooleanTypes),
  }),
  utilityHeader,
  unitIdHeader,
  intCol({
    ident: 'year',
    display: 'Year',
    isKey: true,
    width: 70,
  }),
  intCol({
    ident: 'eventNum',
    display: 'Event Number',
    isKey: true,
    width: 70,
  }),
  intCol({
    ident: 'eventIdx',
    display: 'Event Index',
    isKey: true,
    width: 70,
  }),
  strCol({
    ident: 'revCode',
    display: 'Revision Code',
    ...toSelectionColProps({
      '0': '0 (Insert)',
      // eslint-disable-next-line no-useless-computed-key
      ['R']: 'R (Replace)',
      D: 'D (Delete)',
    }),
    // R is belongs to ramda
  }),
  strCol({
    ident: 'eventType',
    display: 'Event Type',
    ...toSelectionColProps(
      R.compose(
        R.reduce((d1, d2) => ({ ...d1, ...d2 }))({}),
        R.map(e => ({ [e.eventType]: e.eventType }))
      )(eventTypes)
    ),
  }),
  dateTimeCol({
    ident: 'eventStart',
    display: 'Event Start Date',
    width: 150,
    dataFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'eventEnd',
    display: 'Event End Date',
    width: 150,
    dataFormat: 'MM/DD/YYYY HH:mm',
  }),
  numCol({
    ident: 'availCap',
    display: 'Available Capacity',
  }),
  intCol({
    ident: 'causeCode',
    display: 'Cause Code',
  }),
  intCol({
    ident: 'conCode',
    display: 'Contribution Code',
    ...toSelectionColProps(
      R.compose(
        R.reduce((d1, d2) => ({ ...d1, ...d2 }))({}),
        R.map(e => ({ [e]: e }))
      )(['1', '2', '3', '5'])
    ),
  }),
  strCol({
    ident: 'eventTypeExternal',
    // display: 'eventTypeExternal',
    display: 'Contributing Operating Condition',
    ...toSelectionColProps(contribMap),
    width: 350,
    ellipsis: true,
    alignment: 'left',
  }),
  dateTimeCol({
    ident: 'workStart',
    display: 'Work Start',
    width: 150,
    dataFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'workEnd',
    display: 'Work End',
    width: 150,
    dataFormat: 'MM/DD/YYYY HH:mm',
  }),
  intCol({
    ident: 'manHour',
    display: 'Man Hour',
  }),
  strCol({
    ident: 'failCodeFail',
    display: 'Fail Code',
  }),
  strCol({
    ident: 'failCodeAmp',
    display: 'Amp Code',
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 500,
    alignment: 'left',
    ellipsis: true,
  }),
]

const Card99Headers = [
  strCol({
    ident: 'included',
    display: 'Included',
    ...toSelectionColProps(YNBooleanTypes),
  }),
  utilityHeader,
  unitIdHeader,
  intCol({
    ident: 'year',
    display: 'Year',
    isKey: true,
    width: 70,
    sortOrder: 'asc',
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isKey: true,
    width: 70,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'revCode',
    display: 'Revision Code',
    ...toSelectionColProps({
      '0': '0 (Insert)',
      // eslint-disable-next-line no-useless-computed-key
      ['R']: 'R (Replace)',
      D: 'D (Delete)',
    }),
  }),
  strCol({
    ident: 'pFuel',
    display: 'Primary Fuel',
  }),
  numCol({
    ident: 'pBurned',
    display: 'Primary Fuel Burned',
  }),
  numCol({
    ident: 'pAvgHeat',
    display: 'Primary Avg Heat',
  }),
  numCol({
    ident: 'pAsh',
    display: 'Primary Ash Content',
    displayFormat: '0.0',
  }),
  numCol({
    ident: 'pMoist',
    display: 'Primary Moisture Content',
    displayFormat: '0.0',
  }),
  numCol({
    ident: 'pSulfur',
    display: 'Primary Sulfur Content',
    displayFormat: '0.0',
  }),
  strCol({
    ident: 'sFuel',
    display: 'Secondary Fuel',
  }),
  numCol({
    ident: 'sBurned',
    display: 'Secondary Fuel Burned',
  }),
  numCol({
    ident: 'sAvgHeat',
    display: 'Secondary Avg Heat',
  }),
  numCol({
    ident: 'sAsh',
    display: 'Secondary Ash Content',
    displayFormat: '0.0',
  }),
  numCol({
    ident: 'sMoist',
    display: 'Secondary Moisture Content',
    displayFormat: '0.0',
  }),
  numCol({
    ident: 'sSulfur',
    display: 'Secondary Sulfur Content',
    displayFormat: '0.0',
  }),
  strCol({
    ident: 'tFuel',
    display: 'Tertiary Fuel',
  }),
  numCol({
    ident: 'tBurned',
    display: 'Tertiary Fuel Burned',
  }),
  numCol({
    ident: 'tAvgHeat',
    display: 'Tertiary Avg Heat',
  }),
  numCol({
    ident: 'tAsh',
    display: 'Tertiary Ash Content',
    displayFormat: '0.0',
  }),
  numCol({
    ident: 'tMoist',
    display: 'Tertiary Moisture Content',
    displayFormat: '0.0',
  }),
  numCol({
    ident: 'tSulfur',
    display: 'Tertiary Sulfur Content',
    displayFormat: '0.0',
  }),
  strCol({
    ident: 'qFuel',
    display: 'Quaternary Fuel',
  }),
  numCol({
    ident: 'qBurned',
    display: 'Quaternary Fuel Burned',
  }),
  numCol({
    ident: 'qAvgHeat',
    display: 'Quaternary Avg Heat',
  }),
  numCol({
    ident: 'qAsh',
    display: 'Quaternary Ash Content',
    displayFormat: '0.0',
  }),
  numCol({
    ident: 'qMoist',
    display: 'Quaternary Moisture Content',
    displayFormat: '0.0',
  }),
  numCol({
    ident: 'qSulfur',
    display: 'Quaternary Sulfur Content',
    displayFormat: '0.0',
  }),
]

export default connect(mapStateToProps)(DataImportAntd)
